import { FC, memo } from 'react';
import Icon from '../../../Icon/Icon';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import './style.scss';

interface IProps {
  visible: boolean;
  onReset: () => void;
}

const InputResetIcon: FC<IProps> = ({ visible, onReset }: IProps): JSX.Element | null => {
  if (!visible) return null;

  return (
    <div className="input-new__reset-icon" onClick={onReset}>
      <Icon name={Icons.CloseSmall} size={16} color={theme.colors.gray2} className="my-auto" />
    </div>
  );
};

export default memo(InputResetIcon);
